export interface PagePhoto {
  id: number;
  businessID: number;
  fbID: string;
  source: string;
  createdAt: number;
}

export const examplePagePhoto: PagePhoto = {
  id: 1,
  businessID: 1,
  fbID: '1',
  source: 'https://fb.com/1.png',
  createdAt: 0,
};
